/* ============
 * shippingProvider Module Mutations
 * ============
 */

import {
  FETCH_ALL_SHIPPING_PROVIDERS,
  FETCH_CURRENT_SHIPPING_PROVIDER,
} from './../../mutation-types';

export default {
  [FETCH_ALL_SHIPPING_PROVIDERS](state, shippingProviders) {
    state.all = shippingProviders;
  },

  [FETCH_CURRENT_SHIPPING_PROVIDER](state, shippingProvider) {
    state.currentShippingProvider = shippingProvider;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/shippingProvider/mutations.js